export const BASEURL = `${window.location.origin}/api/`;
export const SET_PARAMS = 'SET_PARAMS';
export const SET_QUERY_PARAM = 'SET_QUERY_PARAM';
export const SET_QUERY = 'SET_QUERY';
export const RESET_QUERY = 'RESET_QUERY';
export const SET_ENDPOINT = 'SET_ENDPOINT';
export const RECEIVE_RESULTS = 'RECEIVE_RESULTS';
export const RECEIVE_AND_APPEND_RESULTS = 'RECEIVE_AND_APPEND_RESULTS';
export const RECEIVE_AND_PREPEND_RESULTS = 'RECEIVE_AND_PREPEND_RESULTS';
export const SET_BASE = 'SET_BASE';
export const SET_TEMPLATE_URL = 'SET_TEMPLATE_URL';
export const RECEIVE_RENDERED_TEMPLATE = 'RECEIVE_RENDERED_TEMPLATE';
export const SET_HAS_NEXT = 'SET_HAS_NEXT';
export const SET_HAS_PREVIOUS = 'SET_HAS_PREVIOUS';
export const SET_PAGE = 'SET_PAGE';
export const SET_RESPONSE = 'SET_RESPONSE';
export const SET_IS_FETCHING = 'SET_IS_FETCHING';
export const SET_HAS_RESULTS = 'SET_HAS_RESULTS';
export const SET_FETCHING_ERROR = 'SET_FETCHING_ERROR';
export const SET_FETCHING_SUCCESS = 'SET_FETCHING_SUCCESS';
export const SET_FETCHING_FAILURE = 'SET_FETCHING_FAILURE';
